export default function LinearScaleIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 10H17.5"
        stroke="#455468"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="3" cy="10" r="2" fill="#455468" />
      <circle cx="10.5" cy="10" r="2" fill="#455468" />
      <circle cx="18" cy="10" r="2" fill="#455468" />
    </svg>
  );
}
